import * as DownloadPurpose from "../constants/DownloadPurpose";
import * as OutputFormat from "../constants/OutputFormat";
import * as ts from "../common/Translator";
import {EmailSenderView} from "./EmailSenderView";
import {registerOnWindowResize} from "../common/NamaCommon";
import ReportViewerTemplate from "../compiled-templates/ReportViewerTemplate";
import ReportExportDialogTemplate from "../compiled-templates/ReportExportDialogTemplate";


export class ReportViewer {
    /**
     *
     * @param {ReportViewerPresenter} presenter
     */
    constructor(presenter) {
        this.presenter = presenter;
        this.reportLoaded = false;
    }

    render() {
        let that = this;
        let reportContainer = $(ReportViewerTemplate());
        that.root = reportContainer;
        let reportFrame = reportContainer.find("#reportIFrame");
        reportFrame.attr("src", "assets/namasoft/img/loading.html");
        let exampleDiv = that.presenter.embeddedViewContainer || that.presenter.reportContainer;
        if (!that.presenter.embeddedReportView) {
            $("#main-wrapper").find("#example.page-content-wrapper").remove();
            exampleDiv = $(`<div id="example" class="page-content-wrapper"></div>`);
            exampleDiv.appendTo($("#main-wrapper"));
        }
        that.parent = exampleDiv;
        registerOnWindowResize(reportFrame[0], (e) => {
            that.setIFrameDims(reportFrame);
        });
        reportContainer.appendTo(exampleDiv);
        that.presenter.view = exampleDiv;
        that.toolbarItemsActions(reportContainer, reportFrame);
        reportFrame.on('load', function () {
            if (that.reportLoaded)
                return;
            reportFrame.attr("src", that.presenter.rptUrl);
            that.reportLoaded = true;
            that.updatePagerData(reportFrame, exampleDiv);
            that.root.height(that.root.parent().height());
            that.setIFrameDims(reportFrame);
        });
    }

    toolbarItemsActions(reportContainer, reportFrame) {
        let that = this;
        let buttons = reportContainer.find(".report-icons a[role=button]");
        if (buttons.length) {
            for (let i = 0; i < buttons.length; i++) {
                let current = $(buttons[i]);
                if (current.attr("id"))
                    current.attr('title', ts.translateId(current.attr("id")));
            }
        }
        reportContainer.find("#reportZoomIn").click(() => that.zoomIfNeeded(reportFrame, true));
        reportContainer.find("#reportZoomOut").click(() => that.zoomIfNeeded(reportFrame, false));
        reportContainer.find("#reportRelaunch").click(() => that.presenter.relaunchReport());
        reportContainer.find("#print").click(() => that.presenter.onExport(OutputFormat.PDF, DownloadPurpose.PRINT));
        reportContainer.find("#sendEmailWithResult").click(() => that.showReportViaEmailDialog());
        reportContainer.find("#export").click(() => that.showExportDialog());
    }

    setIFrameDims(reportFrame) {
        let that = this;
        let navbarHeight = $(".navbar").height();
        let innerHeight = window.innerHeight;
        that.frameH = innerHeight - navbarHeight - 100;
        if (that.presenter.viewHeight)
            that.frameH = that.presenter.viewHeight - that.root.find(".quick-icons").outerHeight() - 10;
        that.frameW = window.innerWidth - 20;
        if (that.presenter.viewWidth)
            that.frameW = that.presenter.viewWidth - 50;
        reportFrame.height(that.frameH);
        reportFrame.width(that.frameW);
        let containerDrag = reportFrame.closest(".container-drag");
        let chartContainer = reportFrame.closest(".chartContainer");
        if (containerDrag.length) {
            chartContainer.height(containerDrag.height() - 15);
        }
    }

    updatePagerData(reportFrame, exampleDiv) {
        let that = this;
        if (that.presenter.place.format !== OutputFormat.HTML)
            return;
        if (!that.reportCompletelyLoaded(reportFrame)) {
            setTimeout(() => {
                that.updatePagerData(reportFrame, exampleDiv)
            }, 500);
        } else {
            let dataSource = new kendo.data.DataSource({
                data: new Array(that.reportPagesCount(reportFrame)),
                pageSize: 1
            });
            that.root.find("#pager").kendoPager({
                dataSource: dataSource,
                pageSizes: ["all", 2, 3, 4],
                buttonCount: 5,
                input: true,
                change: () => {
                    let pagerData = that.root.find("#pager").data("kendoPager");
                    that.reportGoToPage(reportFrame, pagerData.page())
                }
            });
            dataSource.read();
        }
    }

    zoomIfNeeded(reportFrame, zoomIn) {
        let that = this;
        let zoomStr = null;
        let reportId = that.presenter.place.reportId;
        if (reportId)
            zoomStr = localStorage.getItem(reportId);
        if (!zoomStr)
            zoomStr = localStorage.getItem("namaHTMLZoom");
        let currentZoom = null;
        if (zoomStr) {
            currentZoom = parseInt(zoomStr);
        }
        if (currentZoom == null)
            currentZoom = 100;
        if (zoomIn)
            currentZoom += 10;
        else
            currentZoom -= 10;
        localStorage.setItem("namaHTMLZoom", currentZoom + "");
        if (reportId)
            localStorage.setItem(reportId, currentZoom + "");
        reportFrame[0].contentWindow.zoomIfNeeded(true);
    }

    reportCompletelyLoaded(reportFrame) {
        return reportFrame[0].contentWindow.pagesCount;
    }

    reportPagesCount(reportFrame) {
        return reportFrame[0].contentWindow.pagesCount();
    }

    reportCurrentPage(reportFrame) {
        return reportFrame[0].contentWindow.currentPage();
    }

    reportGoToPage(reportFrame, pageNumber) {
        reportFrame[0].contentWindow.goToPage(pageNumber - 1);
    }


    showReportViaEmailDialog() {
        let that = this;
        new EmailSenderView(that.presenter).show();
    }

    showExportDialog() {
        let that = this;
        let dialog = $(ReportExportDialogTemplate());
        that.parent.append(dialog);
        dialog.find("#exportAsPDF").click(() => that.presenter.onExport(OutputFormat.PDF, DownloadPurpose.DOWNLOAD));
        dialog.find("#exportAsDOCX").click(() => that.presenter.onExport(OutputFormat.DOCX, DownloadPurpose.DOWNLOAD));
        dialog.find("#exportAsRTF").click(() => that.presenter.onExport(OutputFormat.RTF, DownloadPurpose.DOWNLOAD));
        dialog.find("#exportAsXLSX").click(() => that.presenter.onExport(OutputFormat.XLSX, DownloadPurpose.DOWNLOAD));
        dialog.find("#exportAsXLS").click(() => that.presenter.onExport(OutputFormat.XLS, DownloadPurpose.DOWNLOAD));
        dialog.find("#exportAsODT").click(() => that.presenter.onExport(OutputFormat.ODT, DownloadPurpose.DOWNLOAD));
        dialog.find("#exportAsODS").click(() => that.presenter.onExport(OutputFormat.ODS, DownloadPurpose.DOWNLOAD));
        dialog.find("#exportAsPPTX").click(() => that.presenter.onExport(OutputFormat.PPTX, DownloadPurpose.DOWNLOAD));
        dialog.find("#sendEmailWithResult").click(() => that.showReportViaEmailDialog());
        $(".window-printing > div").removeClass("d-none");
        $(".window-printing > div").addClass("animate__zoomIn");
        $(".btn-close-printing").click(function () {
            $(".window-printing > div").removeClass("animate__zoomIn");
            $(".window-printing > div").addClass("d-none");
            dialog.remove();
        });
    }

    get view() {
        return this.parent;
    }

    onPrint(format) {
        this.presenter.onExport(format, DownloadPurpose.DOWNLOAD)
    }

    sendEmail() {
        this.showReportViaEmailDialog();
    }
}

export function exportButton(id, imgUrl, callback) {
    return {
        type: "button", id: id,
        imageUrl: imgUrl,
        attributes: {
            title: ts.translateId(id),
        },
        click: callback,
    };
}